export const xlsxTypes = {
  SET_XLSX: 'SET_XLSX',
  REMOVE_XLSX: 'REMOVE_XLSX',
  UPDATE_XLSX: 'UPDATE_XLSX',
  UPDATE_XLSX_ERROR: 'UPDATE_XLSX_ERROR',
  CLEAN_XLSX: 'CLEAN_XLSX',
  RESET_XLSX_STATE: 'RESET_XLSX_STATE',
}